

export class ExpenseCategoryBreakdownDto implements IExpenseCategoryBreakdownDto {
    expenseCategoryId!: number;
    categoryName!: string | undefined;
    totalAmount!: number;

    constructor(data?: IExpenseCategoryBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.categoryName = _data["categoryName"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): ExpenseCategoryBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["categoryName"] = this.categoryName;
        data["totalAmount"] = this.totalAmount;
        return data; 
    }
}

export interface IExpenseCategoryBreakdownDto {
    expenseCategoryId: number;
    categoryName: string | undefined;
    totalAmount: number;
}

